export enum IconToActionsExports {
    download = 'pi-download-line',
    reload = 'pi-update-line'
}